<section class="section-sinopse" id="sinopse">

  <img
    class="sinopse-henshi-bg"
    src="assets/images/Henshi-Busto.png"
    alt=""
    aria-hidden="true"
  />

  <div class="sinopse-header">
    <div class="sinopse-label anim">
      <span class="sinopse-eyebrow">Sinopse</span>
    </div>
    <h2 class="sinopse-title anim anim--delay-1"> A Queda das Chamas </h2>

    <div class="sinopse-divider anim anim--delay-2"></div>

    <p class="sinopse-lead anim anim--delay-3">
      O que fazer quando os líderes de um Império desaparecem? —
      Ou quando um poder descontrolado revira o seu mundo? —
      E quando a verdade é apenas uma mentira desfarçada?
    </p>

  </div>

  <div class="sinopse-body">

    <div class="sinopse-text anim anim--delay-2">
      <p>
        Um evento catastrófico destrói um Império cercado de mistério e mentiras.
        Henshi, desperta de uma coma, após 4 anos do assassinado de seus pais, os
        Imperadores do Reino do Fogo.
      </p>
      <p>
        Sem qualquer lembrança do que acontecera, exceto por esse acontecimento que 
        se mantem vívido nos seus piores pesadelos, uma Torre em formato de dragão desperta
        vestigios do seu passado, e com isso, a busca por respostas cresce em seu coração.
      </p>
      <p>
        Envolto em caos, o jovem tenta fugir de sua prisão porém ao ser confrontado um 
        <em>imenso poder destruivo desperta</em> e todo o seu mundo se transforma em um campo de batalha,
        cercado de inimigos, desconfiança e medo.
      </p>
    </div>

    <aside class="sinopse-details anim anim--delay-3">

      <div class="sinopse-detail-item">
        <span class="detail-label">Gênero</span>
        <span class="detail-value">Distopia</span>
      </div>

      <div class="sinopse-detail-item">
        <span class="detail-label">Volume</span>
        <span class="detail-value">A Queda das Chamas</span>
      </div>

      <div class="sinopse-detail-item">
        <span class="detail-label">Capítulos</span>
        <span class="detail-value">20</span>
      </div>

      <div class="sinopse-detail-item">
        <span class="detail-label">Páginas</span>
        <span class="detail-value">360</span>
      </div>

      <a class="sinopse-cta" (click)="scrollTo('#compra', $event)">Adquira</a>

    </aside>

  </div>

</section>
